import React from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import StoreProvider from "../utils/Store/Provider";
import RoutesPrivate from "../utils/RoutesPrivate";

import Global from "../style";

import Home from "./Home";
import Login from "./Login";
import Users from "./Users";
import Event from "./Event";
import Events from "./Events";
import CreateEvent from "./CreateEvent";
import Confirm from "./Confirm";
import NotFount from "./NotFound";
import Search from "./Search";
import Totem from "./Totem";
import AccessControl from "./AccessControl";

import "react-calendar/dist/Calendar.css";
import "react-tabs/style/react-tabs.css";
import "react-toastify/dist/ReactToastify.css";
import DirectConfirmation from "./DirectConfirmation";
import SubscribeToEvent from "./SubscribeToEvent";
import Solicitations from "./Solicitations";
import SubscribeFullPage from "./SubscribeFullPage";
import SubscribeToPay from "./SubscribeToPay";
import PaymentResult from "../components/PaymentResult";
import Credentials from "./Credentials";
import Photo from "./Photo";
import Activities from "./Activities";
import Leads from "./Leads";
import CIMI from "./CIMI";
import FindCimiGuest from "./FindCimiGuest";
import Dashboard from "./EventDashboard";
import MaterialsPage from "./Materials";
import EnrollPage from "./EnrollPage";
import EnrollmentStatusPage from "./EnrollmentStatusPage";
import CredentialPrinter from "./CredentialPrinter";

const Routes = () => (
    <Router>
        <StoreProvider>
            <Switch>
                <Route component={Login} exact path="/login" />
                {/* <Route component={Confirm} exact path="/confirm/:event_id"/> */}
                <Route component={DirectConfirmation} exact path="/confirm/:event_id" />
                {/* <Route component={SubscribeFullPage} exact path="/subscription/:event_id" /> */}
                <Route component={AccessControl} exact path="/controle/:event_id" />
                <Route component={Photo} exact path="/photo/:event_id" />
                <Route component={SubscribeToEvent} exact path="/registro" />

                <RoutesPrivate component={Dashboard} exact path="/dashboard" />

                <RoutesPrivate component={CredentialPrinter} exact path="/print" />

                <Route component={CIMI} exact path="/cimi" />
                <Route component={AccessControl} exact path="/control/:event_id" />
                <RoutesPrivate component={Leads} exact path="/activity/detail/:activity_id" />
                <Route component={AccessControl} exact path="/activity/:event_id/:activity_id" />

                <RoutesPrivate component={Home} exact path="/" />
                <RoutesPrivate component={Users} exact path="/users" />
                <RoutesPrivate component={Activities} exact path="/activities" />
                <RoutesPrivate component={MaterialsPage} exact path="/materials" />

                <RoutesPrivate component={Events} exact path="/events" />
                <RoutesPrivate component={Event} exact path="/events/:id" />
                <RoutesPrivate component={CreateEvent} exact path="/new-events" />
                <RoutesPrivate component={Search} exact path="/search/:event_id" />
                <RoutesPrivate component={Totem} exact path="/totem/:event_id" />
                {/* <RoutesPrivate component={AccessControl} exact path="/control/:event_id" /> */}
                {/* <RoutesPrivate component={AccessControl} exact path="/activity/:event_id/:activity_id" /> */}
                {/* <RoutesPrivate component={Solicitations} exact path="/solicitations"/> */}

                <RoutesPrivate component={FindCimiGuest} exact path="/find/cimi" />
                <RoutesPrivate component={Credentials} exact path="/credential/:event_id" />

                {/* <Route component={SubscribeToPay} exact path="/ingresso" /> */}
                <Route component={EnrollPage} exact path="/ingresso" />
                <Route component={EnrollmentStatusPage} exact path="/status" />
                <Route component={PaymentResult} exact path="/payment-result" />

                <Route component={NotFount} />
            </Switch>
        </StoreProvider>
        <ToastContainer />
        <Global />
    </Router>
);

export default Routes;
